import { render } from "./WCMobileSearchHeaderBar.vue?vue&type=template&id=2e74663e"
import script from "./WCMobileSearchHeaderBar.vue?vue&type=script&lang=js"
export * from "./WCMobileSearchHeaderBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__